/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReceiptFilterDto } from '../../models/receipt-filter-dto';

export interface ReceiptControllerFindFilter$Params {
  centerId: string;
}

export function receiptControllerFindFilter(http: HttpClient, rootUrl: string, params: ReceiptControllerFindFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptFilterDto>> {
  const rb = new RequestBuilder(rootUrl, receiptControllerFindFilter.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReceiptFilterDto>;
    })
  );
}

receiptControllerFindFilter.PATH = '/api/receipt/filter';
